import React from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import Company from '.';
import withQuery from '../../lib/withQuery';
import profileBySlugQuery
from '../../lib/queries/products/profileBySlugQuery.graphql';
import {
  companyProfileCollectionImageConfigurations,
  companyProfileImageConfigurations,
  companyProfileLogoImageConfigurations,
  companyProfileMobileImageConfigurations,
} from '../../lib/imageConfigurations';

const CompanyWithQuery = withQuery(Company);

const CompanyLayout = ({
  children, layoutMaxWidth, layoutMarginBottom, throwOnCompanyNotFound,
}) => {
  const { query: { slug } } = useRouter();

  return (
    <CompanyWithQuery
      query={profileBySlugQuery}
      variables={{
        slug,
        imageConfigurations: companyProfileImageConfigurations,
        mobileImageConfigurations: companyProfileMobileImageConfigurations,
        logoConfigurations: companyProfileLogoImageConfigurations,
        collectionImageConfigurations:
        companyProfileCollectionImageConfigurations,
      }}
      errorMessage="Error loading this company profile"
      layoutMaxWidth={layoutMaxWidth}
      layoutMarginBottom={layoutMarginBottom}
      throwOnCompanyNotFound={throwOnCompanyNotFound}
    >
      {children}
    </CompanyWithQuery>
  );
};

CompanyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  layoutMaxWidth: PropTypes.string,
  layoutMarginBottom: PropTypes.string,
  throwOnCompanyNotFound: PropTypes.bool,
};

CompanyLayout.defaultProps = {
  layoutMaxWidth: '100vw',
  layoutMarginBottom: null,
  throwOnCompanyNotFound: false,
};

export default CompanyLayout;
